import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api';
import { IMG_URL } from '../config/api';
import { useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const OutdoorProductList = () => {
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${BASE_URL}out-word-products`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    setProducts(data.data);
                    setFilteredProducts(data.data);
                }
            })
            .catch(error => console.error('Error fetching outdoor products:', error));
    }, []);

    // Handle search term change
    const handleSearchChange = (event) => {
        const term = event.target.value;
        setSearchTerm(term);
    };

    // Apply date filter
    const handleDateFilter = () => {
        filterProducts(searchTerm, startDate, endDate);
    };

    // Filter products based on search term and date range
    const filterProducts = (term, start, end) => {
        const filtered = products.filter(product => {
            // Check if the customer name matches the search term
            const matchesSearch = product.customer_name.toLowerCase().includes(term.toLowerCase());

            // Convert product's created_at to a Date object
            const productDate = new Date(product.created_at);

            // Handle start and end date filtering
            let matchesDateRange = true;

            // Convert start and end dates to Date objects, if they exist
            const startDateObj = start ? new Date(start) : null;
            const endDateObj = end ? new Date(end) : null;

            // Reset the time of the startDate and endDate objects for accurate date comparison
            if (startDateObj) {
                startDateObj.setHours(0, 0, 0, 0);  // Set to start of the day
            }
            if (endDateObj) {
                endDateObj.setHours(23, 59, 59, 999);  // Set to end of the day
            }

            // If both start and end dates are provided, apply date range filtering
            if (startDateObj && endDateObj) {
                matchesDateRange = productDate >= startDateObj && productDate <= endDateObj;
            }
            // If only start date is provided, ensure product is after the start date
            else if (startDateObj) {
                matchesDateRange = productDate >= startDateObj;
            }
            // If only end date is provided, ensure product is before the end date
            else if (endDateObj) {
                matchesDateRange = productDate <= endDateObj;
            }

            return matchesSearch && matchesDateRange;
        });

        setFilteredProducts(filtered);
    };

    const handleEdit = (id) => {
        navigate(`/EditOutdoorProduct/${id}`);
    };

    const handleAdd = () => {
        navigate('/AddOutdoorProduct');
    };

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this product?")) {
            fetch(`${BASE_URL}out-word-products/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === 1) {
                        setProducts(products.filter(product => product.id !== id));
                        setFilteredProducts(filteredProducts.filter(product => product.id !== id));
                    }
                })
                .catch(error => console.error('Error deleting product:', error));
        }
    };

    const exportToPDF = () => {
        const input = document.getElementById('product-table'); // Target the table
        html2canvas(input).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'mm', 'a4');
            const imgProps = pdf.getImageProperties(imgData);
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
            pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
            pdf.save('outdoor_products.pdf');
        });
    };

    return (
      <div id="main">
        <header className="mb-3">
          <a href="#" className="burger-btn d-block d-xl-none">
            <i className="bi bi-justify fs-3"></i>
          </a>
        </header>

        <div className="page-heading">
          <div className="page-title">
            <div className="row">
              <div className="col-12 col-md-6 order-md-1 order-last">
                <h3>Out Products</h3>
              </div>
            </div>
          </div>
        </div>

        <section className="section">
          <div className="row" id="basic-table">
            <div className="col-12 col-md-12">
              <div className="card">
                <div className="card-header">
                  <div className="row">
                    <div className="col-md-6"></div>
                    <div className="col-md-6 text-end">
                      {/* <button
                        className="btn btn-primary me-2"
                        onClick={handleAdd}
                      >
                        Add Out Product
                      </button> */}
                      <button
                        className="btn btn-secondary"
                        onClick={exportToPDF}
                      >
                        Export to PDF
                      </button>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  {/* Search and Date Filter Section */}

                  {/* Start Date and End Date Filter Section */}
                  <div className="row mb-3">
                    <div className="col-md-4">
                      <label htmlFor="searchTerm" className="form-label">
                        Search by Customer Name
                      </label>
                      <input
                        type="text"
                        id="searchTerm"
                        className="form-control"
                        placeholder="Search product by customer name"
                        value={searchTerm}
                        onChange={handleSearchChange}
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="startDate" className="form-label">
                        Start Date
                      </label>
                      <input
                        type="date"
                        id="startDate"
                        className="form-control"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="endDate" className="form-label">
                        End Date
                      </label>
                      <input
                        type="date"
                        id="endDate"
                        className="form-control"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <button
                      className="btn btn-secondary"
                      onClick={handleDateFilter}
                    >
                      Apply Date Filter
                    </button>
                  </div>

                  <div className="table-responsive" id="product-table">
                    <table className="table table-lg">
                      <thead>
                        <tr>
                          <th>Customer Name</th>
                          <th>Product Image</th>
                          <th>Description</th>
                          <th>Receiver Name</th>
                          <th className="text-end">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredProducts.map((product) => (
                          <tr key={product.id}>
                            <td>{product.customer_name || "N/A"}</td>
                            <td>
                              <img
                                src={`${IMG_URL}uploads/${product.product_image}`}
                                alt={product.product_image}
                                style={{ width: "50px", height: "50px" }}
                              />
                            </td>
                            <td>{product.description || "N/A"}</td>
                            <td>{product.receiver_name || "N/A"}</td>
                            <td className="text-end">
                              {/* <button
                                className="btn btn-success"
                                onClick={() => handleEdit(product.id)}
                              >
                                Edit
                              </button> */}
                              <button
                                className="btn btn-danger ms-2"
                                onClick={() => handleDelete(product.id)}
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
};

export default OutdoorProductList;
    